<template>
    <div class="hourse_resource_edit" v-loading.fullscreen.lock="loading">
        <div class="hourse_resource_edit_header">
            <el-row :gutter="20" style="border-bottom:1px solid #efefef;height:110px">
                <el-col :span="3">
                </el-col>
                <el-col :span="3">
                    <img class="hourse_resource_edit_header_img" :src="'http://crm.joannarealestate.com.cn'+userImg" >
                </el-col>
                <el-col :span="11">
                    <div class="hourse_resource_edit_header_message">
                        <p>{{houseMessage.NegName}}</p>
                        <p>您拥有的房屋资产 · <span style="color:#59A3FA;">{{houseCount}}</span></p>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div class="hourse_resource_edit_header_save">
                    <el-button class="hourse_resource_edit_header_save_btn" type="primary" @click="updateFY">保存</el-button></div>
                </el-col>
            </el-row>
        </div>
        <div class="hourse_resource_edit_content">
            <el-tabs tab-position="left" style="min-height:780px">
                <el-tab-pane label="基本信息">
                    <div class="hourse_resource_edit_content_mes">
                        <div class="hourse_resource_edit_content_mes_header">
                            <h3>帮助房客找到合适房源</h3>
                            <p style="color:#717171;padding-top:4px;">房客在JREChina上搜索房源时可以根据房源的基本情况进行筛选，从而找到符合他们需求的房源。</p>
                        </div>
                        <div style="padding-top:20px">
                            <div class="publish_one form_item">
                                <el-row class="step_item">
                                    <label class="label_title">*最短租期:</label>
                                    <el-select class="mini_select" size="small" v-model="leaseTermValue" placeholder="请选择">
                                        <el-option
                                        v-for="item in leaseTermOptions"
                                        :key="item.KeyValue+'-'+item.Type"
                                        :label="item.KeyName"
                                        :value="item.KeyValue+'-'+item.Type">
                                        </el-option>
                                    </el-select>
                                    <label>*最早可入住时间</label>
                                    <el-date-picker
                                    size="small"
                                    v-model="houseMessage.LiveTime"
                                    value-format="dd/MM/yyyy"
                                    type="date"
                                    suffix-icon="el-icon-date"
                                    placeholder="选择日期">
                                    </el-date-picker>
                                </el-row>
                                <el-row class="step_item">
                                    <label class="label_title">*小区:</label>
                                    <el-autocomplete
                                        :disabled="cityState"
                                        style="width:436px"
                                        v-model="houseMessage.C_COMName"
                                        :fetch-suggestions="querySearchAsync"
                                        value-key="C_COMName"
                                        placeholder="请输入内容"
                                        @select="handleSelect"
                                    ></el-autocomplete>
                                </el-row>
                                <el-row class="step_item">
                                    <label class="label_title">*城市:</label>
                                    <el-select class="mini_select" size="small" v-model="houseMessage.a_c_Name" placeholder="请选择" :disabled="cityState">
                                        <el-option
                                        v-for="item in cityNameOptions"
                                        :key="item.ID"
                                        :label="item.C_ReachName"
                                        :value="item.ID">
                                        </el-option>
                                    </el-select>
                                    <label class="label_title">*区域:</label>
                                    <el-select class="mini_select" size="small" v-model="houseMessage.d_c_Name" placeholder="请选择" :disabled="cityState">
                                        <el-option
                                        v-for="item in areaOptions"
                                        :key="item.ID"
                                        :label="item.C_ReachName"
                                        :value="item.ID">
                                        </el-option>
                                    </el-select>
                                    <label class="label_title">*商圈:</label>
                                    <el-select class="mini_select" size="small" v-model="houseMessage.b_c_Name" placeholder="请选择" :disabled="cityState">
                                        <el-option
                                        v-for="item in bussnessOptions"
                                        :key="item.ID"
                                        :label="item.C_ReachName"
                                        :value="item.ID">
                                        </el-option>
                                    </el-select>
                                </el-row>
                                <el-row class="step_item">
                                    <label class="label_title">*房源类型:</label>
                                    <div style="display: inline-block;margin-left: 80px;margin-top: -18px;">
                                        <el-radio  :disabled="cityState" v-for="item in propertyTypeoptions" :key="item.KeyValue" v-model="houseMessage.WylxId" :label="item.KeyValue" style="margin-bottom: 8px;">{{item.KeyName}}</el-radio>
                                    </div>
                                </el-row>
                                <el-row class="step_item">
                                    <label class="label_title">栋号:</label><el-input size="small" class="mini_input" v-model="houseMessage.ridgepoleNo" placeholder="请输入"></el-input>
                                    <label class="label_title">单元</label><el-input size="small" class="mini_input" v-model="houseMessage.Unit" placeholder="请输入"></el-input>
                                    <label class="label_title">室号</label><el-input size="small" class="mini_input" v-model="houseMessage.House_NO" placeholder="请输入"></el-input>
                                </el-row>
                                <el-row class="step_item">
                                    <label class="label_title">*房源户型:</label>
                                        <el-select class="mini_select" size="small" v-model="houseMessage.Bedroom" placeholder="请选择">
                                            <el-option
                                            v-for="item in bedroomOptions"
                                            :key="item"
                                            :label="item"
                                            :value="item">
                                            </el-option>
                                        </el-select>室
                                        <el-select class="mini_select" size="small" v-model="houseMessage.Livingroom" placeholder="请选择">
                                            <el-option
                                            v-for="item in roomOptions"
                                            :key="item"
                                            :label="item"
                                            :value="item">
                                            </el-option>
                                        </el-select>厅
                                        <el-select class="mini_select" size="small" v-model="houseMessage.Washroom" placeholder="请选择">
                                            <el-option
                                            v-for="item in washroomOptions"
                                            :key="item"
                                            :label="item"
                                            :value="item">
                                            </el-option>
                                        </el-select>卫
                                </el-row>
                                <el-row class="step_item">
                                    <label class="label_title">*楼层:</label>
                                    <el-select class="mini_select" size="small" v-model="houseMessage.lc" placeholder="请选择">
                                        <el-option
                                        v-for="item in floorOptions"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                        </el-option>
                                    </el-select>
                                    <label class="label_title">朝向</label>
                                    <el-select class="mini_select" size="small" v-model="houseMessage.cx" placeholder="请选择">
                                        <el-option
                                        v-for="item in faceOptions"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                        </el-option>
                                    </el-select>
                                    <label class="label_title">面积</label><el-input size="small" class="mini_input" v-model="houseMessage.RoomSize" placeholder="请输入"></el-input>m²
                                </el-row>
                                <el-row class="step_item">
                                    <label class="label_title">*装修情况:</label>
                                    <el-select class="mini_select" size="small" v-model="decorateValue" placeholder="请选择">
                                        <el-option
                                        v-for="item in decorateOptions"
                                        :key="item.KeyValue+'-'+item.Type"
                                        :label="item.KeyName"
                                        :value="item.KeyValue+'-'+item.Type">
                                        </el-option>
                                    </el-select>
                                </el-row>
                                <el-row class="step_item">
                                    <label class="label_title">家居配套:</label>
                                    <el-checkbox-group v-model="furnitures" class="furnishings">
                                        <el-checkbox 
                                        v-for="item in furniturePackage" 
                                        :label="item.KeyValue+'-'+item.Type" 
                                        :key="item.KeyValue+'-'+item.Type" 
                                        :value="item.KeyValue+'-'+item.Type">{{item.KeyName}}</el-checkbox>
                                    </el-checkbox-group>
                                    <el-row class="parking_select">
                                        <el-select class="mini_select "  size="mini" v-model="parkingValue" placeholder="请选择">
                                            <el-option
                                            v-for="item in parkingOptions"
                                            :key="item.KeyValue+'-'+item.Type"
                                            :label="item.KeyName"
                                            :value="item.KeyValue+'-'+item.Type">
                                            </el-option>
                                        </el-select>停车位
                                    </el-row>
                                </el-row>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="房源配置">
                    <div class="hourse_resource_edit_content_mes">
                        <div class="hourse_resource_edit_content_mes_header">
                            <h3>帮助房客找到合适房源</h3>
                            <p style="color:#717171;padding-top:4px;">房客在JREChina上搜索房源时可以根据房源的基本情况进行筛选，从而找到符合他们需求的房源。</p>
                        </div>
                        <div style="padding-top:20px">
                            <div class="publish_tow form_item">
                                <el-row class="step_item">
                                    <label class="label_title">房源特色:</label>
                                    <el-checkbox-group v-model="housefeaturs" class="furnishings">
                                        <el-checkbox 
                                            v-for="item in FeaturesOptions" 
                                            :label="item.ID+'-'+item.FID" 
                                            :key="item.ID+'-'+item.FID" 
                                            :value="item.ID+'-'+item.FID">{{item.KeyWors}}</el-checkbox>
                                    </el-checkbox-group>
                                </el-row>
                                <el-row class="step_item">
                                    <label class="label_title">周边配套:</label>
                                    <el-checkbox-group v-model="housepackage" class="furnishings">
                                        <el-checkbox 
                                            v-for="item in PackageOption" 
                                            :label="item.ID+'-'+item.FID" 
                                            :key="item.ID+'-'+item.FID" 
                                            :value="item.ID+'-'+item.FID">{{item.KeyWors}}</el-checkbox>
                                    </el-checkbox-group>
                                </el-row>
                                <!-- <el-row class="step_item">
                                    <label class="label_title">编辑描述:</label>
                                    
                                    <el-input class="self_textarea" type="textarea" v-model="houseMessage.C_Describe" style="vertical-align: top;width:400px;"></el-input>
                                    
                                </el-row> -->
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="租金">
                    <div class="hourse_resource_edit_content_mes">
                        <div class="hourse_resource_edit_content_mes_header">
                            <h3>帮助房客找到合适房源</h3>
                            <p style="color:#717171;padding-top:4px;">房客在JREChina上搜索房源时可以根据房源的基本情况进行筛选，从而找到符合他们需求的房源。</p>
                        </div>
                        <div style="padding-top:20px">
                            <div class="publish_three form_item">
                                
                                <el-row class="step_item">
                                    <label>您希望的月租金价格:</label>
                                    <el-row class="rent_demo">￥&nbsp;<el-input class="max_input" v-model="houseMessage.MAX_ZJ" placeholder="请输入租金"></el-input>&nbsp;/月</el-row>
                                    <!-- <el-row class="rent_demo"><span><strong>建议:</strong>根据您的房源信息我们建议您以￥15000每月出租</span></el-row> -->
                                    <el-row class="rent_demo">
                                         <el-row>
                                            <el-col :span="2">
                                                <label>价格详情:</label>
                                            </el-col>
                                            <el-col :span="20" style="padding-left:20px">
                                                <el-col :span="8" v-for="(item,index) in priceOption" :key="index">
                                                    <label style="display:inline-block;min-width:60px">{{item.KeyWors}}</label>
                                                    <el-radio v-model="item.value" label="1">包</el-radio>
                                                    <el-radio v-model="item.value" label="0">不包</el-radio>
                                                </el-col>
                                            </el-col>
                                        </el-row>
                                    </el-row>
                                </el-row>
                                <el-row class="step_item">
                                    <label>您的联系方式:</label>
                                    <el-row class="self_demo"><span>姓名:&nbsp;</span><el-input class="max_input" v-model="houseMessage.NegName" placeholder="请输入姓名"></el-input></el-row>
                                    <el-row class="self_demo"><span>邮箱:&nbsp;</span><el-input class="max_input" v-model="houseMessage.NegEmail" placeholder="请输入邮箱"></el-input></el-row>
                                    <el-row class="self_demo"><span>电话:&nbsp;</span><el-input class="max_input" v-model="houseMessage.NegPhone1" placeholder="请输入电话"></el-input></el-row>
                                </el-row>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="图片">
                    <div class="hourse_resource_edit_content_mes">
                        <div class="hourse_resource_edit_content_mes_header">
                            <h3>帮助房客找到合适房源</h3>
                            <p style="color:#717171;padding-top:4px;">房客在JREChina上搜索房源时可以根据房源的基本情况进行筛选，从而找到符合他们需求的房源。</p>
                        </div>
                        <div style="padding-top:20px">
                            <el-row class="step_item">
                                <label>请上传您的房源照片:</label>
                                <el-row class="upload_img">
                                    <el-upload class="upload_demo"
                                        :before-upload="fileChange"
                                        list-type="picture-card"
                                        action=""
                                        :on-preview="handlePictureCardPreview"
                                        :on-remove="handlePictureRemove"
                                        :file-list="fileList"
                                        multiple
                                        >
                                        <el-button size="small" type="primary">点击上传</el-button>
                                    </el-upload>
                                    <el-dialog :visible.sync="dialogVisible">
                                        <img width="100%" :src="dialogImageUrl" alt="">
                                    </el-dialog>
                                </el-row>
                            </el-row>
                            <el-row class="step_item" v-show="imgArr.length==0?false:true">
                                <label>您已发布的房源图片</label>
                                <el-row :gutter="24" style="padding-top:20px;">
                                    <el-col :span="8" v-for="item in imgArr" :key="item">
                                        <div class="grid-content bg-purple" style="overflow:hidden;height:200px;position:relative;">
                                            <img :src="'http://crm.joannarealestate.com.cn'+item" style="width:100%;">
                                            <el-button style="position:absolute;left:0;top:0;" type="danger" icon="el-icon-delete" circle @click="deleteImg(item)"></el-button>
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-row>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import First from '@/pages/publishHouse/components/publishFist.vue'
import Second from '@/pages/publishHouse/components/publishSecond.vue'
import Third from '@/pages/publishHouse/components/publishThird.vue'
export default {
    data(){
        return {
            loading: false,
            userImg:'',
            houseCount: 0,
            furniturePackage: [],//配套
            leaseTermOptions: [],//最短租期
            decorateOptions: [],//装修情况
            parkingOptions: [],//停车位
            propertyTypeoptions: [],//物业类型
            leaseTermValue:'',
            cityState: false,
            cityNameOptions:[],
            areaOptions: [],
            bussnessOptions: [],
            bedroomOptions: [1,2,3,4,5,6,7,8,9,10],
            roomOptions: [0,1,2,3,4,5],
            washroomOptions: [0,1,2,3,4,5,6],
            floorOptions: ['一层', '低层', '中层', '高层', '顶层'],
            faceOptions: [
                '朝东|East facing', 
                '朝南|South facing', 
                '朝西|West facing', 
                '朝北|North facing', 
                '朝东南|Southeast facing', 
                '朝西南|Southwest facing', 
                '朝西北|Northwest facing', 
                '朝东北|Northeast facing'
            ],
            decorateValue: '',
            furnitures: [],
            parkingValue: '',
            FeaturesOptions: [],
            PackageOption: [],
            housefeaturs: [],
            housepackage: [],
            priceOption: [],
            pricedetail: [],
            dialogImageUrl: '',
            dialogVisible: false,
            imgArr: [],
            houseMessage: {},
            fileList:[]
        }
    },
    components:{
        First,
        Second,
        Third
    },
    methods:{
        getMessage(id){
            this.$get('/Handler/FYGL.ashx',{action:'GetFyByID1',House_ID:id},data => {
                this.cityState=true;
                this.houseMessage = data[0];
                if(this.houseMessage.ImageUrls){
                    this.imgArr = this.houseMessage.ImageUrls.split(',');
                    
                }else{

                }
                
                this.decomposeTypeIds();
                this.decomposeTypeIds1()
            },error => {

            });
        },
        deleteImg(url){
            var index = this.imgArr.indexOf(url);
            if (index > -1) { 
               this.imgArr.splice(index, 1);
            }
            
        },

        decomposeTypeIds(){
            //反选TypeIds
            let that = this;
            let typeIdsArr = this.houseMessage.TypeIds.split(',');

            _.each(typeIdsArr, item => {
                let thatItem = item
                ////反选最短租期
                _.each(this.leaseTermOptions, item => {
                    if(item.KeyValue == thatItem.split('-')[0] && item.Type == thatItem.split('-')[1]){
                        that.leaseTermValue = item.KeyValue + '-' + item.Type;
                    }
                });
                ////反选装修
                _.each(this.decorateOptions, item => {
                    if(item.KeyValue == thatItem.split('-')[0] && item.Type == thatItem.split('-')[1]){
                        that.decorateValue = item.KeyValue + '-' + item.Type
                    }
                });
                //反选家居配套
                _.each(this.furniturePackage, item => {
                    if(item.KeyValue == thatItem.split('-')[0] && item.Type == thatItem.split('-')[1]){
                        that.furnitures.push(item.KeyValue+'-'+item.Type);
                    }
                });
                //反选停车位
                _.each(this.parkingOptions, item => {
                    if(item.KeyValue == thatItem.split('-')[0] && item.Type == thatItem.split('-')[1]){
                        that.parkingValue = item.KeyValue + '-' + item.Type
                    }
                });
            });
            _.each(this.propertyTypeoptions, item => {
                //反选物业类型
                if(this.houseMessage.WylxId == item.KeyValue){
                    this.houseMessage.WylxId = item.KeyValue
                }
            });
        },
        decomposeTypeIds1(){
            //反选TypeIds1
            let that = this;
            let typeIds1Arr = this.houseMessage.TypeIds1.split(',');
            //反选价格详情
            _.each(this.priceOption , item => {
                let findIndex = _.findIndex(typeIds1Arr , childItem => {
                    return childItem == item.ID + '-' + item.FID;
                });
                if(findIndex != -1){
                    item['value'] = '1';
                }else{
                    item['value'] = '';
                }
            });
            
            _.each(typeIds1Arr, item => {
                let thatItem = item
                //反选房源特色
                _.each(this.FeaturesOptions, item => {
                    if(item.ID == thatItem.split('-')[0] && item.FID == thatItem.split('-')[1]){
                        that.housefeaturs.push(item.ID+'-'+item.FID);
                    }
                });
                //反选周边配套
                _.each(this.PackageOption, item => {
                    if(item.ID == thatItem.split('-')[0] && item.FID == thatItem.split('-')[1]){
                        that.housepackage.push(item.ID+'-'+item.FID);
                    }
                });
            })
        },
        handleRemove(file, fileList) {
        
        },
        fileChange(file){
            if(this.fileList.length > 2){
                 return
            }
            let formData = new FormData();
            formData.append('file',file);
            this.loading = true;
            let actionParams = {
               action:'UploadPic1',
               type:1,
               fyNo:this.houseMessage.FYNO
            }
            this.$imgPost('http://netapi.jrechina.com/Handler/FYGL.ashx',formData,actionParams,data => {
                this.loading = false;
                let obj = {
                    url : 'http://crm.joannarealestate.com.cn' + data
                }
                formData.delete('file');
                this.fileList.push(obj);
            },error => {
                this.loading = false;
                if(error){
                    this.$message.error(error);
                }
                
            });
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handlePictureRemove(file, fileList) {
            
        },
        createdhouseNO(){
            //生成房源编号
            let params = {
                action: 'GetFYBH1',
                dzh: this.houseMessage.ridgepoleNo,//栋座号
                lpid: this.houseMessage.BH //楼盘编号
            }
            this.$get('/Handler/FYGL.ashx',params,data => {
                this.houseMessage.FYNO = data.FYNO;
            },err => {

            })
        },
        getPropertyType(){
            //获取房源类型
            this.$get('/Handler/FYGL.ashx',{action:'GetHouseProperties1',oper:'types_of_properties'},(data)=>{
                data.forEach(function(el){
                el.KeyValue = String(el.KeyValue);
                });
                this.propertyTypeoptions = data;
            },(err)=>{
                this.$message.error(err);
            });
        },
        gethousePrice(){
            //价格
            this.$get('/Handler/FYGL.ashx',{action:'GetHouseProperties1',oper:'price_details'},data => {
                this.priceOption = data
            },err => {

            })
        },
        decorate(){
            //装修
            this.$get('/Handler/FYGL.ashx',{action:'GetHouseProperties1',oper:'renovation_condition'},data => {
                this.decorateOptions = data
            },err => {

            })
        },
       gethousefurniture(){
            //获取家居配套
            this.$get('/Handler/FYGL.ashx',{action:'GetHouseProperties1',oper:'furniture_package'},data => {
                this.furniturePackage = data
            },err => {

            })
        },
        gethouseParking(){
            //获取停车位
            this.$get('/Handler/FYGL.ashx',{action:'GetHouseProperties1',oper:'parking_space'},data => {
                this.parkingOptions = data
            },err => {

            })
        },
        gethouseFeatures(){
            //装修
            this.$get('/Handler/FYGL.ashx',{action:'GetHouseProperties1',oper:'property_features'},data => {
                this.FeaturesOptions = data
            },err => {

            })
        },
        gethousePackage(){
            //装修
            this.$get('/Handler/FYGL.ashx',{action:'GetHouseProperties1',oper:'peripheral_package'},data => {
                this.PackageOption = data
            },err => {
 
            })
        },
        getOwnerHouseCount(){
            //获取房源数量
            var params = {
                Action: 'InitFYCount1'
            }
            this.$get('/Handler/FYGL.ashx',params,(data)=>{
                this.houseCount = data;
            },(err)=>{

            });
        },
        gethouseLease(){
            //最短租期
            let params = {
                action: 'GetHouseProperties1',
                oper: 'shortest_lease'
            }
            this.$get('/Handler/FYGL.ashx',params,data => {
                this.leaseTermOptions = data;
               
            },err => {

            });
            
        },
        
        querySearchAsync(queryString,cb){
            this.cityState = false;
            this.houseMessage.a_c_Name = '';
            this.houseMessage.b_c_Name = '';
            this.houseMessage.d_c_Name = '';
            this.$get('/Handler/FYGL.ashx',{Action:'selectCommunityList1',COMName:this.houseMessage.C_COMName}, data => {
                cb(data);
            },error => {
                this.$message.error(error);
            });
        },
        handleSelect(item) {
            // 这里的item会把一些初始化的对象变为undefined，导致了选其他的时候报错
            this.cityState = true;
            _.forEach(item , (value,key)=>{
                this.houseMessage[key] = value;
            });
        },
        addHouseClick(){
            
            // console.log(this.houseMessage);
        },
        getTypeIds(){
            let typeIds = [];
            typeIds = this.furnitures;
            typeIds.push(this.decorateValue);
            typeIds.push(this.leaseTermValue);
            typeIds.push(this.parkingValue);
            typeIds = _.union(typeIds);
            return typeIds.join(',');
        },
        getTypeIds1(){
            let typeIds1 = [];
            typeIds1 = this.housefeaturs.concat(this.housepackage);
            _.forEach(this.priceOption, item => {
                if(item.value == 1){
                    typeIds1.push(item.ID+'-'+item.FID)
                }
            })
            typeIds1 = _.union(typeIds1);
            return typeIds1.join(',')
        },
        updateFY(){
            //保存
            this.loading = true;
            this.houseMessage.TypeIds = this.getTypeIds();
            this.houseMessage.TypeIds1 = this.getTypeIds1();
            delete this.houseMessage.C_Describe;
            delete this.houseMessage.E_Describe;
            delete this.houseMessage.ImageUrls;
            let list2 = [];
            if(this.fileList.length != 0){
                    _.each(this.fileList, item => {
                    list2.push(item.url.replace('http://crm.joannarealestate.com.cn','')+'|1');
                });
            }
            _.each(this.imgArr, item => {
                list2.push(item+'|1');
            })
            this.houseMessage.attURL = list2.join(',');
            var params = {
                JsonData: JSON.stringify(this.houseMessage)
            }
            this.$post('/Handler/FYGL.ashx',params,{Action: 'UpdateFY1'},data => {
                this.loading = false;
                this.$alert('信息修改成功！', '操作提示',{
                    confirmButtonText: '确定',
                    callback: action => {
                         this.$router.push({path:'/houseResource/houseResourceMessage'});
                    }
                });
            },err => {
                this.loading = false;
                // this.$message.error(err);
            })
        }
    },
    created(){
        this.getOwnerHouseCount();
        // this.getOwner();
        this.getPropertyType();
        
        this.gethouseLease();
        this.gethousefurniture();
        this.gethouseParking();
        this.gethouseFeatures();
        this.gethousePackage();
        this.gethousePrice();
        this.decorate()
        // this.getCity()
        
        this.getMessage(this.$route.query.id);
        this.userImg = (JSON.parse(localStorage.getItem('JRE_MESSAGE')) || {}).Pic;
    }

}
</script>

<style>
.hourse_resource_edit{
    width: 900px;
}
.hourse_resource_edit_header_img{
    width:70px;
    height: 70px;;
    border-radius: 100px;
    float: left;
    margin-left: 10px;
    position: relative;
    top:20px;
}
.hourse_resource_edit_header_message{
    display: inline-block;
    position: relative;
    top:26px;
}
.hourse_resource_edit_header_save{
    position: relative;
    top:40px;
}
.hourse_resource_edit_content{

}
.hourse_resource_edit_content_mes{
    /* padding:10px; */
    /* width:100%; */
}
.hourse_resource_edit_content_mes_header{
    padding:16px 0;
    border-bottom:1px solid #efefef;

}
    .hourse_resource_edit .publish_one{
        padding-left: 25px;
    }
    .hourse_resource_edit .step_title{
        color: #278bdd;
        font-size: 14px;
        padding: 25px;
    }
    .hourse_resource_edit .step_item{
        margin-bottom: 15px;
        font-size: 14px;
        border-bottom: 1px dashed #efefef;
        padding-bottom: 15px;
        position: relative;
    }
   .hourse_resource_edit .step_item label.label_title{
        text-align: right;
        padding-right: 8px;
        min-width: 70px;
        display: inline-block;
    }
    .hourse_resource_edit .mini_input{
        display: inline-block;
        width: 100px;
    }
    .hourse_resource_edit .furnishings{
        display: inline-block;
        padding-left: 80px;
        margin-top: -18px;
    }
    .hourse_resource_edit .form_item{
        margin-left: 25px;
    }
    .hourse_resource_edit .mini_select{
        width: 100px;
        height: 40px;
    }
    .hourse_resource_edit .el-input__inner{
        height: 30px;
        line-height: 30px;
    }
    .hourse_resource_edit .el-input__icon{
        line-height: 30px;
    }
    
   .hourse_resource_edit .upload_demo{
        border: 1px dashed #efefef;
        padding: 20px;
        width: 80%;
        margin-top: 10px;
        min-height: 150px;
        text-align: center;
    }
    .hourse_resource_edit .el-upload--picture-card{
        border: none;
        width: 80px;
        height: 32px;
        margin: 0 auto;
        margin-top: 30px;
    }
    .hourse_resource_edit .max_input{
        display: inline-block;
        width: 330px;
        margin-top: 10px;
    }
    .hourse_resource_edit .rent_demo,.self_demo{
        padding-left: 20px;
        margin-bottom: 10px;
    }
    .hourse_resource_edit .self_demo label{
        margin-right: 5px;
    }
    .hourse_resource_edit .rent_demo .radio_select{
        margin-left: 60px;
        margin-bottom: 15px;
    }
    .hourse_resource_edit .rent_demo .radio_select label.priceitem{
        width: 65px;
        display: inline-block;
        text-align: right;
    }
   .hourse_resource_edit .rent_demo .el-radio{
        margin-right: 20px;
    }
    .hourse_resource_edit .el-radio__label,.el-checkbox__label{
        padding-left: 3px;
    }
   .hourse_resource_edit .publish_one .furnishings .el-checkbox{
        margin-right: 0;
        width: 90px;
        margin-bottom: 5px;
    }
    .hourse_resource_edit .publish_tow .furnishings .el-checkbox{
        margin-right: 0;
        width: 135px;
        margin-bottom: 5px;
    }
   .hourse_resource_edit .parking_select{
        display: inline-block;
        padding-left: 77px;
    }
    .hourse_resource_edit .parking_select .mini_select{
        width: 90px;
        height: 20px;
    }
    .hourse_resource_edit .parking_select .el-input__inner{
        height: 20px;
        padding: 0 5px;
    }
    
    .hourse_resource_edit .parking_select .el-input__icon{
        line-height: 20px;
    }
    .hourse_resource_edit .boots{
        text-align: right;
        padding-right: 100px;
    }
    .hourse_resource_edit .boots span{
        display: inline-block;
        width: 70px;
        height: 30px;
        line-height: 30px;
        color: #333;
        font-size: 14px;
        background: #278bdd; 
        text-align: center;
        border-radius: 5px;
        cursor: pointer;
    }
    .hourse_resource_edit .boots span.previous_step{
        background: #fff;
        margin-right: 80px;
    }
    .hourse_resource_edit .boots span.next_step,
    .hourse_resource_edit .boots span.creat_house{
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/pages/houseResource/components/houseResourceEdit.vue